<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <historial-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
         <!-- Column: Despachado por -->
          <template #cell(internalRecords.userChanged.fullname)="data">
            <span v-if="data.item.state === 'Despachado' && data.item.internalRecords.length > 0">
              {{ data.item.internalRecords[0].userChanged.fullname }}
            </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(created_at)="data">
            <span>{{ moment(data.item.created_at).format('yyyy-MM-DD') }}</span>
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" class="" @click="detalle(data.item)" v-b-tooltip.hover.top="'Ver'" variant="flat-info">
              <feather-icon icon="EyeIcon" />
            </b-button>
            <!--<b-button
              v-if="data.item.state !== 'Despachado' && data.item.state !== 'Anulado' && data.item.state !== 'Cancelado'"
              size="sm"
              class=""
              @click.prevent="edit(data.item)"
              v-b-tooltip.hover.top="'Editar'"
              variant="flat-success"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>-->
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script> 
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import historialFilters from './historialFilters.vue'
import InternalMovement from '@/services/InternalMovement'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return{
        showLoading: false,
        records: [],
        fields: [
          { key: 'establishmentOrigin.name', label: 'Tienda Origen', sortable: true },
          { key: 'establishmentDestiny.name', label: 'Tienda Destino', sortable: false },
          { key: 'created_at', label: 'Fecha de Creación', sortable: false },
          { key: 'documentCode', label: 'N° Documento', sortable: false },
          { key: 'state', label: 'Estado', sortable: true},
          { key: 'internalRecords.userChanged.fullname', label: 'Despachado por', sortable: false},
          { key: 'userReceiver.fullname', label: 'Recogido por', sortable: false},
          { key: 'actions', label: 'Acciones'}
        ],
        arrayFilters: [],
        currentPage: 1,
        entries: [10, 20, 50, 100],
        showEntrie: 10,
        totalElements: 0,
        id: 0,
        sort: 'id',
        order: 'desc',
    }
  },
  components:{
    historialFilters
  },
  mounted(){
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    detalle(item) {
      this.$router.push('/inventario/entrada/detalle/' + item.id)
    },
    async getData(){
      let datosUser = JSON.parse(localStorage.getItem('userData'))
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      this.arrayFilters.push({
          keyContains: 'userRegisterId',
          key: 'equals',
          value: datosUser.id
        });
      
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`
      const resp = await InternalMovement.getInternMovements(url, this.$store)
      if (resp.data.rows.length != 0) {
        this.records = resp.data.rows
        this.totalElements = resp.data.rows.length
      }
      this.showLoading = false
    },
  },
}


</script>